import { firestoreAction } from 'vuexfire'
import { db } from '@/config/firebase'
import firebase from 'firebase'

const devices = {
  namespaced: true,
  state: {
    devices: [],
    device: null
  },
  actions: {
    bindAllRef: firestoreAction(context => {
      if (context.rootGetters['users/getActiveAdmin']) {
        return context.bindFirestoreRef('devices', db.collection('devices'))
      }
    }),
    bindRef: firestoreAction(context => {
      return context.bindFirestoreRef(
        'devices',
        db
          .collection('devices')
          .where('owner', '==', context.rootGetters['users/getActiveUserId'])
      )
    }),
    bindDocRef: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        'device',
        db.collection('devices').doc(id)
      )
    })
  },
  getters: {
    getDevices: state => state.devices,
    getDevice: state => state.device
  },
  modules: {
    units: {
      namespaced: true,
      state: {
        units: []
      },
      actions: {
        bindRef: firestoreAction(context => {
          return context.bindFirestoreRef(
            'units',
            db
              .collection('deviceUnits')
              .where(
                'owner',
                '==',
                context.rootGetters['users/getActiveUserId']
              )
          )
        })
      },
      getters: {
        getUnits: state => state.units
      }
    },
    groups: {
      namespaced: true,
      state: {
        groups: []
      },
      actions: {
        bindRef: firestoreAction(context => {
          return context.bindFirestoreRef(
            'groups',
            db
              .collection('deviceGroups')
              .where(
                'owner',
                '==',
                context.rootGetters['users/getActiveUserId']
              )
          )
        })
      },
      getters: {
        getGroups: state => state.groups
      }
    },
    logs: {
      namespaced: true,
      state: {
        logs: []
      },
      actions: {
        bindRef: firestoreAction((context, id) => {
          return context.bindFirestoreRef(
            'logs',
            db
              .collection('devices')
              .doc(id)
              .collection('logs')
          )
        })
      },
      getters: {
        getLogs: state => state.logs
      }
    },
    snapshots: {
      namespaced: true,
      state: {
        snapshot: {}
      },
      actions: {
        bindRef: firestoreAction((context, id) => {
          const ref = db
            .collection('devices')
            .doc(id)
            .collection('snapshots')
            .doc('--latest--')

          // create default document if it didn't exist
          return ref.get().then(doc => {
            if (!doc.exists) {
              return ref
                .set({
                  timestamp: firebase.firestore.FieldValue.serverTimestamp()
                })
                .then(() => {
                  return context.bindFirestoreRef('snapshot', ref)
                })
            } else {
              return context.bindFirestoreRef('snapshot', ref)
            }
          })
        })
      },
      getters: {
        getSnapshot: state => state.snapshot
      }
    }
  }
}

export default devices
